import React, { useState, useEffect } from 'react';
import './SocialSection.css';

const SocialSection = ({ restaurant }) => {
  const [videos, setVideos] = useState(null);

  useEffect(() => {
    if (!restaurant) return;

    setVideos(null);

    const query = encodeURIComponent(`${restaurant.name} ${restaurant.boro} NYC food`);
    const key = process.env.REACT_APP_YOUTUBE_API_KEY;
    const url = `https://www.googleapis.com/youtube/v3/search?part=snippet&q=${query}&type=video&maxResults=3&key=${key}`;

    fetch(url)
      .then((res) => res.json())
      .then((data) => setVideos(data.items ?? []))
      .catch(() => setVideos([]));
  }, [restaurant]);

  // Hide the section until results are in, and hide if none found
  if (!videos || videos.length === 0) return null;

  return (
    <section className="social-section">
      <h3 className="social-heading">Videos</h3>
      <div className="social-list">
        {videos.map((video) => {
          const { videoId } = video.id;
          const { title, channelTitle, thumbnails } = video.snippet;
          const thumb = thumbnails.medium?.url ?? thumbnails.default?.url;
          const href = `https://www.youtube.com/watch?v=${videoId}`;

          return (
            <a
              key={videoId}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="social-card"
            >
              <img src={thumb} alt={title} className="social-thumb" />
              <div className="social-info">
                <p className="social-title">{title}</p>
                <p className="social-channel">{channelTitle}</p>
                <span className="social-badge">YouTube</span>
              </div>
            </a>
          );
        })}
      </div>
    </section>
  );
};

export default SocialSection;
